/** @format */

import { ChangeDetectionStrategy, Component, Signal, computed, input, output } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconCaretDown
} from '@dsg-tech/homefield-angular-icons';
import {
	analyticsSortMethodValues,
	customerRatingSort,
	familyPageDropdownValues,
	searchDropdownValues
} from '@plp/data-access/constants';
import {
	refreshProductList,
	selectProductListSEO,
	selectSelectedSort,
	updateSelectedSort
} from '@plp/data-access/state';

import { ProductAnalyticsService } from '@shared/data-access/analytics';
import { Store } from '@ngrx/store';
import { UtilityService } from '@shared/data-access/services';

@Component({
	selector: 'plp-components-sort',
	imports: [HomefieldIconLibraryModule],
	templateUrl: './sort.component.html',
	styleUrl: './sort.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortComponent {
	readonly isDisabled = input(false);
	readonly sortByCustomerRatingEnabled = input(false);

	readonly tabPressed = output<void>();

	readonly seoData = this.store.selectSignal(selectProductListSEO);
	readonly dropdownValues: Signal<{ label: string; value: number }[]> = computed(() => {
		if (this.seoData()?.catgroupId) {
			return this.sortByCustomerRatingEnabled()
				? [...familyPageDropdownValues, customerRatingSort]
				: familyPageDropdownValues;
		} else {
			return searchDropdownValues;
		}
	});
	readonly selectedValue: Signal<{ label: string; value: number }> =
		this.store.selectSignal(selectSelectedSort);

	constructor(
		private readonly analyticsService: ProductAnalyticsService,
		private readonly store: Store,
		private readonly utilityService: UtilityService,
		private readonly homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconCaretDown]);
	}

	selectValue(selector: HTMLSelectElement): void {
		// Since a <select> element can have multiple selections if it's configured
		// for multiple selection (<select multiple>),
		// we use [0] to target the first (and only) selected option.
		const selectedOption = selector.selectedOptions[0];

		const selectedLabel = selectedOption.label;
		const selectedValue = selectedOption.value;

		this.store.dispatch(
			updateSelectedSort({
				selectedSort: { label: selectedLabel, value: parseInt(selectedValue) }
			})
		);
		this.store.dispatch(refreshProductList());
		const analyticsValue = analyticsSortMethodValues.find(
			(dropdownOption) => parseInt(selectedValue) === dropdownOption.value
		)?.text;
		this.setAnalyticsEvent(analyticsValue);
		selector.blur();
		const plpContainerElem = document.getElementById('plp-list-container');
		this.utilityService.scrollToElement(plpContainerElem, { behavior: 'instant' });
	}

	onTabKeyDown(): void {
		this.tabPressed.emit();
	}

	private setAnalyticsEvent(sortValue: string): void {
		const refinementUpdateObj = { UpdateType: 'SortMethod', UpdateValue: sortValue };
		this.analyticsService.triggerAnalyticsEvent('ResultsViewUpdate', refinementUpdateObj);
	}
}
